import { matchPath } from 'react-router-dom';

export const selectCurrentSubMenuByPath = (url: string): boolean => {
  if (url) {
    return matchPath(window.location.pathname, url) !== null;
  }
  return false;
};
